import { Button, IconButton, useTheme } from '@mui/material';
import Iconify from 'src/components/iconify';
import { useBreakpoints } from 'src/hooks/useBreakpoints';
import { useLocales } from 'src/locales';
import { useDocShareDialog } from '../DocShareDialog';

export const ShareDocButton = ({ docId }: { docId: string }) => {
  const { showDocShareDialog } = useDocShareDialog();
  const { translate } = useLocales();
  const { isSmallMobile } = useBreakpoints();
  const theme = useTheme();

  if (isSmallMobile) {
    return (
      <IconButton onClick={() => showDocShareDialog({ docId })}>
        <Iconify icon="tabler:share-3" color={theme.palette.primary.main} />
      </IconButton>
    );
  }

  return (
    <Button
      variant="contained"
      startIcon={<Iconify icon="tabler:share-3" />}
      onClick={() => showDocShareDialog({ docId })}
    >
      {translate('shared.buttons.share')}
    </Button>
  );
};
